export default "__VITE_ASSET__eeq$2iz___"